import { Box, Divider } from '@mui/material';
import './realTimeStatusGraph.scss';

import BarGraph from '../BarGraph/BarGraph';
import useFetchStatusAPI from '../../hooks/useFetchStatusAPI';
import AppLoader from '../AppLoader/AppLoader';

import { useTranslation } from 'react-i18next';
import { useEffect } from 'react';

const RealTimeStatusGraph = ({
  statusType,
  services,
  setIsStatusAPILoading
}) => {
  const { t } = useTranslation();
  const api =
    statusType === 'Gold'
      ? 'REACT_APP_STATUS_API_GOLD'
      : statusType === 'BAT'
      ? 'REACT_APP_STATUS_API_BAT'
      : 'REACT_APP_STATUS_API_PROD';
  const urlType = api + '_HOURLY_URL';

  const options = {
    headers: { 'x-api-key': process.env[api] }
  };

  const url = process.env[urlType];

  const { data, loading } = useFetchStatusAPI(
    url,
    options,
    statusType,
    services
  );

  useEffect(() => {
    if (loading) {
      setIsStatusAPILoading(true);
    } else if (!loading) {
      setIsStatusAPILoading(false);
    }
	// eslint-disable-next-line
  }, [loading]);

  const statusObject = {
    UP: t('support.status-monitoring.realTimeStatusGraph.statusUP'),
    Orange: 'Degraded',
    DOWN: t('support.status-monitoring.realTimeStatusGraph.statusDown')
  };

  return (
    <>
      {!loading ? (
        <Box className="realTimeStatuspage">
          <Box className="cardsContainer">
            {data &&
              data.map((status, i) => {
                const obj = status['data'][0];

                const label =
                  status['API'] === 'OrderReshopShop'
                    ? 'OrderReshop'
                    : status['API'];

                const render =
                  (label as string) !== 'OrderReshopPrice' &&
                  (label as string) !== 'OrderChangeFQTV';

                return (
                  render && (
                    <article
                      className="realTimeGraphCard"
                      key={i}
                      //tabIndex={0}
                      aria-label={`${label} current status: ${
                        statusObject[status['LiveStatus']]
                      }`}
                    >
                      <div className="cardHeader">
                        <div className='titleImg'>
                        <img
                          src={
                            services[
                              label === 'OrderReshop'
                                ? 'OrderReshopShop'
                                : label
                            ]
                          }
                          alt={`${label} service icon`}
                          style={{ width: '40px' }}
                          aria-hidden="true"
                        />
                        <h3 className="serviceTitle">
                          {label.toString() === 'OrderRetrieve'
                            ? 'OrderView'
                            : label}
                        </h3>
                        </div>
                        <div className='statusMsg'>
                        <span className='lastCall' style={{textAlign:"end"}}>{t('support.status-monitoring.lastCall')}</span>
                          <span
                            className={`currentStatus status${status['LiveStatus']}`}
                          >
                            {statusObject[status['LiveStatus']]}
                          </span>
                        </div>
                      </div>
                      <Divider aria-hidden="true" tabIndex={-1} />

                      <BarGraph
                        service={status['API']}
                        data={obj}
                        renderTooltipContent={RealTimeDataTooltip}
                        type={'hourly'}
                      />
                    </article>
                  )
                );
              })}
          </Box>
        </Box>
      ) : (
        <AppLoader />
      )}
    </>
  );
};

const RealTimeDataTooltip = (data: any) => {
  const [date, time] = data.date?.split(' ');
  const [hours, minutes] = time?.split(':');
  const finaleDate = `${date} ${hours}:${minutes} - ${hours}:59`;
  return (
    <div aria-hidden="true" tabIndex={-1}>
      <div className="tooltip-heading heading-padding">{data.statusTitle}</div>
      <hr />
      <div className="tooltip-eta">
        <span>{finaleDate}</span>
      </div>
    </div>
  );
};

export default RealTimeStatusGraph;
